import { CommitteeStatus } from "../../models/Committee";
import { InstitutionCommittee } from "../../models/Committee";
import { CountyCommittee } from "../../models/Committee";
import { RegionalCommittee } from "../../models/Committee";
import { MinistryCommittee } from "../../models/Committee";

export const DEFAULT_INSTITUTION_COMMITTEE: InstitutionCommittee = {
  id: 0,
  institution: { id: 0, name: "", oib: "", code: "", subCode: "" },
  dateFrom: new Date(),
  dateTo: new Date(),
  statusId: CommitteeStatus.NotDefined,
  isSelected: false,
  statusName: "",
  institutionTownName: "",
  institutionName: "",
  hasDecisions: false,
};

export const DEFAULT_COUNTY_COMMITTEE: CountyCommittee = {
  id: 0,
  countyId: 0,
  statusId: CommitteeStatus.NotDefined,
  isSelected: false,
  statusName: "",
  hasDecisions: false,
  county: { id: 0, name: "" },
  countyName: "",
};

export const DEFAULT_REGIONAL_COMMITTEE: RegionalCommittee = {
  id: 0,
  countyId: 0,
  county: { id: 0, name: "" },
  countyName: "",
  name: "",
  statusId: CommitteeStatus.NotDefined,
  isSelected: false,
  statusName: "",
  hasDecisions: false,
  dateFrom: new Date(),
  dateTo: new Date(),
  institutionList: [],
};

export const DEFAULT_MINISTRY_COMMITTEE: MinistryCommittee = {
  id: 0,
  statusId: CommitteeStatus.NotDefined,
  isSelected: false,
  statusName: "",
  hasDecisions: false,
  dateFrom: new Date(),
  dateTo: new Date(),
};
